module.exports = __webpack_public_path__ + "img/step410.6013e075.png";